import { useAuth } from "@k3-tech/react-kit";

export function SplashScreen({ children }: { children: React.ReactNode }) {
    const { status } = useAuth();
    if (status === "idle" || status === "loading") {
        // NOTE: Karena muncul sangat brief, mending blank aja.
        return null;
        // return (
        //     <div inert className="fixed w-screen h-screen flex items-center justify-center">
        //         <div className="w-24 h-24 text-brand-500">
        //             <img alt="" src="/loading.svg" />
        //         </div>
        //     </div>
        // );
    }

    return <>{children}</>;
}
